/*
 * @Author: HB-BruceWang
 * @Date: 2025-02-13 14:53:16
 * @LastEditors: HB-BruceWang
 * @LastEditTime: 2025-02-27 19:24:26
 * @FilePath: \shopify-web\src\pages\paid-extended-warranty\snippets\form\js\part-two.js
 * @Description: 付费延保表单 - 版块二渲染
 *
 * Copyright (c) 2025 by Hello Tech, All Rights Reserved.
 */

import JustValidate from 'just-validate';
import { renderPEWSelect } from './pew-select';
import { getPEWPurchaseChannel } from './get-pew-purchase-channel';
import { renderFileUpload } from './file-upload';
import { applyPEW } from "@utils/api.js";

export function initPartTwo(ValidateMessages, isEditMode) {
  // 购买渠道下拉列表
  let pewChannelListInstance;

  // 产品购买渠道
  const $purchaseChannel = $('#product_purchase_channel');

  // 购买凭证
  const $uploadProof = $('#pewFormTwo #upload_proof');

  // 版块二表单校验
  let validateFormTwo = undefined;
  const formTwoValidate = () => {
    validateFormTwo = new JustValidate('#pewFormTwo');

    validateFormTwo
      .addField('#product_purchase_channel', [
        {
          rule: 'required',
          errorMessage: ValidateMessages.required
        },
      ], {
        errorsContainer: document.querySelector('[data-field="product_purchase_channel"]'),
      })
      .addField('#product_order', [
        {
          rule: 'required',
          errorMessage: ValidateMessages.required
        },
        {
          validator: (value) => {
            // 正则校验：允许#、空格、英文、数字、中横线
            return /^[A-Za-z0-9-\s#]+$/.test(value);
          },
          errorMessage: ValidateMessages.orderSNFormatCheck,
        }
      ], {
        errorsContainer: document.querySelector('[data-field="product_order"]'),
      })
      .addField('#product_sn', [
        {
          rule: 'required',
          errorMessage: ValidateMessages.required
        },
        {
          validator: (value) => {
            // 正则校验：允许#、空格、英文、数字、中横线
            return /^[A-Za-z0-9-\s#]+$/.test(value);
          },
          errorMessage: ValidateMessages.orderSNFormatCheck,
        }
      ], {
        errorsContainer: document.querySelector('[data-field="product_sn"]'),
      })
  }

  // 获取最终表单数据
  const getEndFormData = () => {
    const channelType = $purchaseChannel.attr('data-type');
    let formData = {
      oId: $('#pew_id').val(), // 延保服务Order ID
      warrantyProjectId: $('#pew_service').val(), // 延保服务项目ID
      warrantyType: $purchaseChannel.attr('data-type') === 'online' ? 0 : 1, // 延保类型，0：线上，1：线下
      productBuyChannel: $purchaseChannel.val(), // 【延保服务对应的产品】的购买渠道
      productOrderSn: $('#product_order').val(), // 【延保服务对应的产品】的订单order ID
      productSn: $('#product_sn').val(), // 【延保服务对应的产品】SN号
    };

    if (channelType === 'offline') {
      //【延保服务对应的产品】购买时间
      formData.productBuyTime = $('#product_purchase_time').val();

      // 购买凭证清单
      formData.attachmentsUrls = JSON.parse($uploadProof.attr('data-img-urls'));
    }
    return formData;
  }

  // 清空表单数据
  const resetForm = () => {
    $('#pewFormOne')[0].reset();
    $('#pewFormTwo')[0].reset();

    // 初始化购买渠道
    initChannelList();

    // 初始化日期
    initDatePicker();

    // 初始化购买凭证
    $('#pewFormTwo .add-image').trigger('resetEvent');

    // 重置 版块一表单 接口请求
    $('#pewFormTwo .btn-submit').trigger('resetEvent');
  }

  // 渲染替换对应产品名称的标题
  const renderLabel = () => {
    let productName = $('#pew_service').attr('data-type');

    if (!isEditMode) {
      $('.part-two .title').each(function () {
        const currText = $(this).text();
        $(this).empty().text(currText.replaceAll('${ProductName}', productName));
      })

      const $secondSubtitle = $('.part-two .subtitle');
      const currSubTitleText = $secondSubtitle.text();
      $secondSubtitle.empty().text(currSubTitleText.replaceAll('${ProductName}', productName));
    }

    $('#pewFormTwo label').each(function () {
      const currText = $(this).attr('data-text');
      const $labelText = $(this).find('.label-text');
      if (isEditMode) {
        $labelText.text(currText);
      } else {
        $labelText.empty().text(currText.replaceAll('${ProductName}', productName));
      }
    })
  }

  // 日期初始化
  const initDatePicker = () => {
    flatpickr(".flatpickr", {
      locale: window.pageInfo.lang,
      wrap: true,
      maxDate: "today",
      disableMobile: true
    });

    $('#pewFormTwo .icon-date').off('click').on('click', function () {
      $("#product_purchase_time").trigger('click');
    })
  }

  // 购买渠道变化监听
  const handleChannel = (type) => {
    const $offlineItems = $('#pewFormTwo .offline-item');
    if (type === 'offline') {
      // 表单校验更新
      validateFormTwo
        .addField('#product_purchase_time', [
          {
            rule: 'required',
            errorMessage: ValidateMessages.required
          },
        ], {
          errorsContainer: document.querySelector('[data-field="product_purchase_time"]'),
        })
        .addField('#upload_proof', [
          {
            rule: 'files',
            value: {
              files: {
                extensions: ['jpg', 'jpeg', 'png'],
                types: ['image/jpg', 'image/jpeg', 'image/png'],
              },
            },
            errorMessage: ValidateMessages.imgFormatCheck
          },
          {
            rule: 'files',
            value: {
              files: {
                maxSize: 1024 * 1024 * 10, // 10M
              },
            },
            errorMessage: ValidateMessages.maxSize
          },
          {
            validator: () => {
              return $uploadProof.attr('data-uploading') === 'false';
            },
            errorMessage: ValidateMessages.imgUploading,
          },
          {
            validator: () => {
              return Number($uploadProof.attr('data-total')) > 0;
            },
            errorMessage: ValidateMessages.minFilesCount,
          },
        ], {
          errorsContainer: document.querySelector('[data-field="upload_proof"]'),
        });

      $offlineItems.show();
    } else {
      // 表单校验更新
      if (validateFormTwo.fieldIds.has('#product_purchase_time')) {
        validateFormTwo.removeField('#product_purchase_time').removeField('#upload_proof')
      }

      $offlineItems.hide();
    }
  }

  // 购买渠道下拉列表 初始化
  const initChannelList = () => {
    // 销毁旧实例
    if (pewChannelListInstance) {
      pewChannelListInstance.destroy();
    }
    const dataList = getPEWPurchaseChannel();

    // 创建新实例
    pewChannelListInstance = new renderPEWSelect('product_purchase_channel', dataList);

    let type = $purchaseChannel.attr('data-type');
    handleChannel(type);

    // 购买渠道变化监听
    $purchaseChannel.on('customValChange', function () {
      validateFormTwo.revalidateField('#product_purchase_channel');

      let type = $(this).attr('data-type');
      handleChannel(type);
    });
  }

  // 返回版块一
  const backToPartOne = () => {
    $('.pew-form').attr('data-back-status', 'true');

    validateFormTwo.refresh();
    $('#pewFormOne .btn-next').attr('disabled', false);
    $('.pew-form .part-two').hide().siblings('.part-one').show();

    $('html, body').animate({
      scrollTop: $('.part-one').offset().top - 100
    }, 500, 'swing');
  }

  // 事件监听
  const handleEvent = () => {
    // 上一步
    $('#pewFormTwo .prev-link').off('click').on('click', function () {
      backToPartOne();
    })

    // 表单提交
    $('#pewFormTwo .btn-submit').off('click').on('click', function () {
      const $btnSubmit = $(this);

      // 表单校验
      validateFormTwo.revalidate().then(async (isValid) => {
        if (isValid) {
          // 验证通过后提交表单
          try {
            $btnSubmit.attr('disabled', true);
            const currFormData = getEndFormData();
            const info = await applyPEW(currFormData);
            if (info.success) {
              pushSuccessMessage(info.message);

              // 线上渠道 校验凭证是否已上传
              currFormData.warrantyType === 0 && $('#pewFormTwo .add-image').trigger('onlineCheckProofEvent');

              // 清空表单
              resetForm();

              // 返回版块一
              backToPartOne();
            }
          } catch (error) {
            pushErrorMessage(error.message);
          } finally {
            $btnSubmit.attr('disabled', false);
          }
        }
      });
    })

    window.addEventListener('unload', () => {
      resetForm();
    });
  }

  // 初始化
  const init = () => {
    // 渲染对应产品名称
    renderLabel();

    // 表单二校验
    formTwoValidate();

    // 购买渠道下拉列表 初始化
    initChannelList();

    // 日期初始化
    initDatePicker();

    // 购买凭证渲染
    renderFileUpload(validateFormTwo, ValidateMessages);

    // 事件监听
    handleEvent();
  }

  init();
}